// Session-scoped memory of the email address awaiting verification. Written
// when registration / join succeeds (or login is refused with "verify first")
// and read by VerifyEmailPage so the resend form is pre-filled instead of
// making the user re-type — and risk mistyping — their address.
// sessionStorage over a query param: no PII in URLs or browser history.
const KEY = "adam.pendingVerificationEmail";

export function getPendingVerificationEmail(): string {
  try {
    return sessionStorage.getItem(KEY) ?? "";
  } catch {
    return "";
  }
}

export function setPendingVerificationEmail(email: string): void {
  try {
    sessionStorage.setItem(KEY, email);
  } catch {
    // Storage unavailable (private mode) — the user types the email manually.
  }
}

export function clearPendingVerificationEmail(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Storage unavailable — nothing to clear.
  }
}
